export const LockStatus = {
  LOCKED: 'locked',
  UNLOCKED: 'unlocked',
  UNSELECTED: 'unselected'
};
